<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import Button from '../common/Button.svelte';
  import ImportantLink from '../ui-components/ImportantLink.svelte';
  import SmallTitle from '../common/SmallTitle.svelte';
  import PressRelease from '../ui-components/PressRelease.svelte';
  import OfficialsBox from '../ui-components/OfficialsBox.svelte';
  import ContactsBox from '../ui-components/ContactsBox.svelte';
  import PageBox from '../ui-components/PageBox.svelte';
  import Common from '../js/common.js';

  if (!Global.pages.includes('for-press')) {
    window.location.href = window.localStorage.getItem('currentPage') || './';
  }

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let pressReleases = [];
  let contacts = [];
  let importantLinks = [];
  let officials = [];
  let page;

  let loading = true;
  let error = false;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/forPress/get`);

    if (response.ok) {
      const data = await response.json();

      pressReleases = data.pressReleases;
      contacts = data.contacts;
      importantLinks = data.importantLinks;
      officials = data.officials;
      page = data.page;
      user = data.user;

      pressReleases = Common.sortArrayOfObjectsByKey(pressReleases, ['date'], true);

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');
    } else {
      error = true;
    }

    loading = false;
  })();

  const i18n = {
    pageTitle: {
      cs: `Pro média | ${Global.project.name.cs}`,
      en: `For press | ${Global.project.name.en}`,
    },
    title: {
      cs: 'Pro média',
      en: 'For press',
    },
    contacts: {
      cs: 'Kontakty',
      en: 'Contacts',
    },
    addPressRelease: {
      cs: 'Přidat tiskovou zprávu',
      en: 'Add press release',
    },
    editContacts: {
      cs: 'Upravit kontakty',
      en: 'Edit contacts',
    },
    editImportantLinks: {
      cs: 'Upravit důležité odkazy',
      en: 'Edit important links',
    },
    editOfficials: {
      cs: 'Upravit oficiály',
      en: 'Edit officials',
    },
  };
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='for-press' bind:lang bind:user/>

<Title title={i18n.title[lang]} img='title/for-press.jpg' bind:lang bind:user/>

<div class='for-press'>
  <Loading bind:display={loading}/>
  <Error bind:display={error} bind:lang/>

  {#if !loading && !error}
    {#if importantLinks.length > 0 || user}
      <div class='for-press-important-links'>
        {#if user}
          <div class='for-press-important-links-admin'>
            <Button value={i18n.editImportantLinks[lang]} icon='edit' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
              onClick={() => { window.location.href = './#/admin/for-press-important-links'; }}/>
          </div>
        {/if}

        {#each importantLinks as importantLink}
          <div class='for-press-important-links-important-link'>
            <ImportantLink value={importantLink} bind:lang/>
          </div>
        {/each}
      </div>
    {/if}

    <div class='for-press-content'>
      <div class='for-press-content-main'>
        {#if user}
          <Button value={i18n.addPressRelease[lang]} icon='add' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
            onClick={() => { window.location.href = './#/admin/press-releases/add'; }}/>
        {/if}

        {#if pressReleases.length > 0}
          <div class='for-press-content-main-press-releases'>
            {#each pressReleases as pressRelease}
              <PressRelease value={pressRelease} bind:lang bind:user/>
            {/each}
          </div>
        {/if}

        {#if officials.length > 0}
          <div class='for-press-content-main-officials'>
            <OfficialsBox officials={officials} bind:lang/>
          </div>
        {/if}

        {#if user}
          <Button value={i18n.editOfficials[lang]} icon='edit' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
            onClick={() => { window.location.href = './#/admin/officials'; }}/>
        {/if}

        <PageBox value={page} page='for-press' bind:lang bind:user/>
      </div>

      {#if contacts.length > 0 || user}
        <div class='for-press-content-contacts'>
          {#if user}
            <div class='for-press-content-contacts-admin'>
              <Button value={i18n.editContacts[lang]} icon='edit' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
                onClick={() => { window.location.href = './#/admin/for-press-contacts'; }}/>
            </div>
          {/if}

          <SmallTitle value={i18n.contacts[lang]}/>

          <ContactsBox contacts={contacts} bind:lang/>
        </div>
      {/if}
    </div>
  {/if}
</div>

<Footer bind:lang/>

<style>
  .for-press {
    display: flex;
    flex-direction: column;
    gap: 40px;

    max-width: 1450px;

    padding: 40px 60px;

    margin: auto;
  }

  .for-press-important-links {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .for-press-important-links-admin {
    width: 100%;
  }

  .for-press-important-links-important-link {
    flex-grow: 1;
    flex-basis: calc((100% - 80px) / 5);
  }

  .for-press-content {
    display: flex;
    justify-content: space-between;
    gap: 40px;
  }

  .for-press-content-main {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 40px;

    width: calc((100% - 40px) / 3 * 2);
  }

  .for-press-content-main-press-releases {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .for-press-content-contacts {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 20px;

    width: calc((100% - 40px) / 3);
  }

  .for-press-content-contacts-admin {
    margin-bottom: 20px;
  }

  @media only screen and (max-width: 1300px) {
    .for-press-important-links-important-link {
      flex-basis: calc((100% - 40px) / 3);
    }

    .for-press-content {
      flex-direction: column;
    }

    .for-press-content-main {
      width: 100%;
    }

    .for-press-content-contacts {
      width: 100%;
    }
  }

  @media only screen and (max-width: 900px) {
    .for-press {
      padding: 40px;
    }

    .for-press-important-links-important-link {
      flex-basis: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 600px) {
    .for-press-important-links-important-link {
      flex-basis: 100%;
    }
  }

  @media only screen and (max-width: 350px) {
    .for-press {
      padding: 40px 20px;
    }
  }
</style>
